import s, { useRef as E, useState as x, useTransition as w, useEffect as y, useCallback as b, useMemo as S } from "react";
import { c as _ } from "./useKeyDown-88662051.mjs";
import { B as u } from "./useClickOutside-55c64a80.mjs";
import { B as h } from "./Button-eec2778c.mjs";
import "./Icon-e01b6482.mjs";
import "./app-51178863.mjs";
const v = "pagination", C = "pagination__items", L = "pagination__item", k = "pagination__item--selected", g = {
  pagination: v,
  paginationItems: C,
  paginationItem: L,
  paginationItemSelected: k
};
function N(n) {
  const { value: t = 1, count: e, onChange: r } = n, a = E(null), [i, c] = x(P(t, e)), [, d] = w();
  y(() => c(P(t, e)), [t, e]);
  const m = b(
    (o) => {
      const l = typeof o == "number" ? o : o(i), I = P(l, e);
      I !== i && (c(I), r && d(() => r(I)));
    },
    [i, r, e]
  ), f = b(
    (o) => {
      switch (o.key) {
        case "ArrowRight":
          return a.current?.focus(), m((l) => l + 1);
        case "ArrowLeft":
          return a.current?.focus(), m((l) => l - 1);
      }
    },
    [m]
  ), p = S(() => A(i, e), [i, e]);
  return { page: i, handlePageChange: m, itemList: p, handleKeyDown: f, containerRef: a };
}
function P(n, t) {
  return Math.max(Math.min(n, t), 1);
}
function A(n, t, e = 1, r = 5) {
  const a = "...";
  return t === 1 ? [e] : t === 2 ? [e, t] : t <= r ? Array(t).fill(0).map((i, c) => c + 1) : n <= 2 ? [e, e + 1, e + 2, a, t] : n >= t - 1 ? [e, a, t - 2, t - 1, t] : [e, a, n, a, t];
}
function V(n) {
  const { i18n: t = {}, count: e } = n, {
    btnNextText: r = "Goto next page",
    btnPrevText: a = "Goto previous page",
    btnPageText: i = "Goto page"
  } = t, { page: c, handlePageChange: d, itemList: m, handleKeyDown: f, containerRef: p } = N(n);
  return !e || e === 0 ? null : /* @__PURE__ */ s.createElement(u, { topPadding: u.Padding.NONE, bottomPadding: u.Padding.SMALL }, /* @__PURE__ */ s.createElement(u.Content, null, /* @__PURE__ */ s.createElement(
    "div",
    {
      className: g.pagination,
      "data-testid": "pagination",
      onKeyDown: f,
      tabIndex: -1,
      ref: p
    },
    /* @__PURE__ */ s.createElement(
      h.Arrow,
      {
        arrowDirection: "left",
        "data-testid": "pagination-prev",
        title: a,
        disabled: c === 1,
        onClick: () => d((o) => o - 1)
      }
    ),
    /* @__PURE__ */ s.createElement("ul", { className: g.paginationItems, "data-testid": "pagination-items" }, m.map((o, l) => /* @__PURE__ */ s.createElement("li", { key: l, role: "none" }, /* @__PURE__ */ s.createElement(
      D,
      {
        page: o,
        selectedPage: c,
        onSelect: d,
        title: i
      }
    )))),
    /* @__PURE__ */ s.createElement(
      h.Arrow,
      {
        arrowDirection: "right",
        "data-testid": "pagination-next",
        title: r,
        disabled: c === e,
        onClick: () => d((o) => o + 1)
      }
    )
  )));
}
function D({
  page: n,
  selectedPage: t,
  onSelect: e,
  title: r
}) {
  const a = typeof n == "number", i = a && n === t;
  return /* @__PURE__ */ s.createElement(
    "button",
    {
      role: "listitem",
      "data-testid": "pagination-item-" + n,
      "aria-current": t === n ? "true" : void 0,
      className: _(
        g.paginationItem,
        i && g.paginationItemSelected
      ),
      disabled: !a,
      onClick: () => a && e?.(n),
      title: a ? `${r} ${n}` : void 0
    },
    n
  );
}
export {
  V as Pagination
};
//# sourceMappingURL=Pagination.js.map
